<template>
  <div>
    <div>
      {{ labelArchive.amount }}
    </div>
    <div class="labels-container">
      <MatrioshkaVisualizationColumnLabel
        v-for="(label, index) in thisUnitLabels"
        :key="label.id"
        :index="index"
        :label="label"
        :all-labels="labelArchive"
        @select-item="$emit('select-item', $event)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MatrioshkaVisualizationColumnLabel from './MatrioshkaVisualizationColumnLabel.vue';

export default {
  name: 'MatrioshkaVisualization',
  props: {
    labelArchive: {
      type: Array,
      required: true,
    },
    unitId: {
      type: Number,
      required: true,
    },
    debugStatuses: {
      type: Array,
      required: true,
    },
  },
  components: {
    MatrioshkaVisualizationColumnLabel,
  },
  computed: {
    ...mapGetters('labelArchive', [
      'labelArchiveStatuses',
    ]),
    thisUnitLabels() {
      return this.labelArchive
        .filter(label => label.unitId === this.unitId)
        .filter(label => this.debugStatuses.includes(label.labelStatus))
        .filter(label => label.containers.length === 0);
    },
  },
  methods: {
    statusColor(s) {
      const status = this.labelArchiveStatuses.find(st => st.id === s);
      return status?.color || '#171717';
    },
  },
};
</script>

<style scoped lang="scss">
.labels-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
}

</style>
